import React, { useState, useEffect } from 'react';
import { EmailContentTypeProps } from "./EmailContentType.props";
import {Box, Tooltip, Typography} from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './EmailContentType.css'
import EmailContentTypeBody from '../EmailContentTypeBody/EmailContentTypeBody';
import {TOOLTIP_MESSAGES} from "../../constants/constants";
import { CognitiveBiasType } from '../EmailContentTypeBody';

const EmailContentType : React.FC<EmailContentTypeProps> = ({ data={} }) => {
  const [cognitiveBias, setCognitiveBias] = useState<CognitiveBiasType | undefined>(undefined);
  const [themes, setThemes] = useState<CognitiveBiasType | undefined>(undefined);

  useEffect(() => {
    if (!data || data.length === 0) {
      return;
    }

    setCognitiveBias(data.cognitive_bias);
    setThemes(data.themes);
  }, [data]);

  return (
    <>
      <div className={'email-content-type-container'}>
        <Box width={'100%'} mb={'37px'}>
          <Box width={'100%'} display="flex" justifyContent="space-between">
            <Typography sx={{fontFamily:'Righteous', fontSize:24, fontWeight: 400, color: '#193051'}}>Email Content Biases</Typography>
            <Typography>
              <Tooltip
                title={TOOLTIP_MESSAGES.PROFILE_EMAIL_CONTENT_TYPE}
                placement="top-start"
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontSize: '13px',
                      [`&.MuiTooltip-tooltipPlacementTop`]: {
                        maxWidth: 'fit-content',
                      },
                    },
                  },
                }}
              >
                <InfoOutlinedIcon sx={{position: "relative", top: "4px", cursor: "pointer"}} fontSize={"medium"} htmlColor={"#193051"}/>
              </Tooltip>
            </Typography>
          </Box>
          <Box width={'100%'} display="flex" justifyContent="space-between">
            <Typography className='email-content-type-text'>
              Insights into which biases may influence your phishing responses.
            </Typography>
          </Box>
        </Box>
        <div className={'email-content-type-body'}>
          <EmailContentTypeBody cognitiveBias={cognitiveBias} themes={themes} />
        </div>
      </div>
    </>
  );
};

export default EmailContentType;
